import { IncommingMessageParamsMap, IncommingMessages, MessageParamsMap, Messages } from './messages';

export type RequestId = string;

type SubscribeCallback<Data> = (data: Data) => void;

interface IncommingMessage {
	type: IncommingMessages;
	data: any;
}

const subscribers: Record<RequestId, SubscribeCallback<IncommingMessageParamsMap[IncommingMessages]>> = {};

export function publish<Name extends Messages>(name: Name, params: MessageParamsMap[Name]) {
	window.parent.postMessage(
		JSON.stringify({
			messageType: 'widget-direct-message',
			data: {
				name,
				params
			}
		}),
		'*'
	);
}

export function subscribe<Name extends IncommingMessages = any>(
	requestId: RequestId,
	callback: SubscribeCallback<IncommingMessageParamsMap[Name] | null>
) {
	const timer = setTimeout(() => {
		callback(null);
		delete subscribers[requestId];
	}, 3000);

	subscribers[requestId] = (data: any) => {
		callback(data.result);
		clearTimeout(timer);
		delete subscribers[requestId];
	};
}

function onMessage(event: MessageEvent) {
	try {
		const message: IncommingMessage = JSON.parse(event.data);
		const messageSubscriber = subscribers[message.data?.requestId];

		messageSubscriber?.(message.data);
	} catch {}
}

window.addEventListener('message', onMessage);
